export default {
  metaInfo: {
    title: '登入頁面',
  },
  data() {
    return {
      passwordmethod: "password",
      input: {
        uniform: "29030340",
        account: "james",
        password: "1234"
      }
    }
  },
  computed: {
    companyname: {
      get() {
        return this.$store.state.system.companyname
      }
    },
    company: {
      get() {
        return this.$store.state.system.company
      }
    },
    codeself: {
      get() {
        return this.$store.state.system.codemyself
      }
    }
  },
  methods: {
    taggetpwd() {
      this.passwordmethod = this.passwordmethod == "password" ? "text" : "password"
    },

    async login() {
      const loginstatus = await this.$store.dispatch("Login/Login", this.input);

      if (loginstatus) {
        this.$router.push({
          name: "myorder",
          params: {
            company: this.company
          }
        });
      } else {
        console.log("登入失誤");
      }
    }
  },

  components: {},

}
